import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TrackerTable = _resolveComponent("TrackerTable")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    max_width: "90%",
    min_width: _ctx.$responsive.desktop ? undefined : '30rem',
    "dialog-class": "tracker-expanded",
    onClickOutside: $options.close,
    onAfterLeave: _cache[0] || (_cache[0] = $event => (_ctx.$emit('after-leave')))
  }, {
    content: _withCtx(() => [
      _createVNode(_component_TrackerTable, {
        widget: $props.widget,
        expanded: "",
        onCollapse: $options.close
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["widget", "onCollapse"])
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["min_width", "onClickOutside"]))
}